$(document).ready(function () {
    // Always use the filter state rendered by the server. Browsers can otherwise
    // restore stale checkbox values after a normal refresh.
    $('.category-checkbox, .gift-idea-checkbox').each(function () {
        $(this).prop('checked', String($(this).data('selected')) === '1');
    });

    function updateFilterCounts() {
        ['category', 'occasion', 'collection', 'popular'].forEach(function (type) {
            var selected = type === 'category' ? $('.category-checkbox:checked') : $('.gift-idea-checkbox:checked').filter(function () {
                return $(this).data('gift-idea-type') === type;
            });
            var values = selected.map(function () {
                return String(type === 'category' ? $(this).data('category-id') : $(this).data('gift-idea-slug'));
            }).get().filter(function (value, index, allValues) {
                return allValues.indexOf(value) === index;
            });

            $('[data-filter-count="' + type + '"]').text(values.length ? values.length : '');
        });

        $('.filter-trigger').each(function () {
            $(this).toggleClass('is-active', $(this).find('.filter-count').text() !== '');
        });
    }
    updateFilterCounts();

    //------- prevent default action for dropdown -----------
    $('.dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });

    //-------- categories checkbox active/ inactive --------
    $('.page-item .page-link').on('click', function () {
        $('.page-item .page-link').removeClass('active');
        $(this).addClass('active');
    });

    //-------- sidebar filter open and close ---------------------
    $('.btn-open-filter').on('click', function () {
        $('.box-filter-sidebar').css('display', 'block');
        $('.box-filter-sidebar').css('left', '0');
        $('.box-filter-sidebar-overlay').css('display', 'block');
    });

    //-------- sidebar filter closed when click on overlay -------------
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.btn-open-filter').length
            && !$(event.target).closest('.box-filter-sidebar').length) {
            $('.box-filter-sidebar').css('left', '-370px');
            $('.box-filter-sidebar-overlay').css('display', 'none');
        }
    });

    //-------- render products based on all selected filters --------------
    function filterProducts() {
        var selectedCategories = $('.category-checkbox:checked').map(function () {
            return String($(this).data('category-id'));
        }).get().filter(function (categoryId, index, categoryIds) {
            return categoryIds.indexOf(categoryId) === index;
        });

        syncFiltersToUrl(selectedCategories);
        updateFilterCounts();

        var filterUrl = new URL(window.location.href);
        filterUrl.searchParams.delete('page');

        $.ajax({
            url: productRoute + filterUrl.search,
            type: 'GET',
            success: function (data) {
                $('.hot-item-list').html($(data).find('.hot-item-list').html());
                $('.box-pagination').html($(data).find('.box-pagination').html());
            },
            error: function (error) {
                console.log('Error:', error);
            }
        });
    }

    function syncFiltersToUrl(selectedCategories) {
        var url = new URL(window.location.href);
        var filterKeys = [];
        var selectedBudgets = [];

        url.searchParams.forEach(function (value, key) {
            if (key === 'gift_idea_budget' || key.indexOf('gift_idea_budget[') === 0) {
                selectedBudgets.push(value);
            }
            if (key === 'categories_id' || key.indexOf('categories_id[') === 0
                || key === 'gift_idea_type' || key === 'gift_idea_slug'
                || /^gift_idea_(budget|occasion|collection|popular)(\[.*\])?$/.test(key)) {
                filterKeys.push(key);
            }
        });
        if (url.searchParams.get('gift_idea_type') === 'budget' && url.searchParams.get('gift_idea_slug')) {
            selectedBudgets.push(url.searchParams.get('gift_idea_slug'));
        }

        filterKeys.forEach(function (key) {
            url.searchParams.delete(key);
        });

        selectedCategories.forEach(function (categoryId) {
            url.searchParams.append('categories_id[]', categoryId);
        });

        selectedBudgets.filter(function (slug, index, slugs) {
            return slugs.indexOf(slug) === index;
        }).forEach(function (slug) {
            url.searchParams.append('gift_idea_budget[]', slug);
        });

        ['occasion', 'collection', 'popular'].forEach(function (type) {
            $('.gift-idea-checkbox:checked').filter(function () {
                return $(this).data('gift-idea-type') === type;
            }).map(function () {
                return String($(this).data('gift-idea-slug'));
            }).get().filter(function (slug, index, slugs) {
                return slugs.indexOf(slug) === index;
            }).forEach(function (slug) {
                url.searchParams.append('gift_idea_' + type + '[]', slug);
            });
        });

        url.searchParams.delete('page');

        window.history.replaceState({}, '', url.toString());
    }

    // Trigger filterProducts function when category checkboxes change
    $('.category-checkbox').change(function () {
        var categoryId = $(this).data('category-id');
        var isChecked = $(this).is(':checked');

        $('.category-checkbox').filter(function () {
            return $(this).data('category-id') == categoryId;
        }).prop('checked', isChecked);

        filterProducts();
    });

    $('.gift-idea-checkbox').change(function () {
        var type = $(this).data('gift-idea-type');
        var slug = $(this).data('gift-idea-slug');
        var isChecked = $(this).is(':checked');

        $('.gift-idea-checkbox').filter(function () {
            return $(this).data('gift-idea-type') === type
                && $(this).data('gift-idea-slug') === slug;
        }).prop('checked', isChecked);

        filterProducts();
    });

});
